<table>
  <thead>
    <tr>
      <th>{{ 'placeholders.serialNumber' | translate }}</th>
      <th>{{ title }}</th>
      <th>{{ 'placeholders.quantity' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of options; let i = index">
      <td>{{ i + 1 }}</td>
      <td>{{ item.text }}</td>
      <td>
        <input
          [placeholder]="placeholder"
          [class.disabled]="formControl.disabled"
          type="number"
          [value]="formControl.value[item.id]"
          (input)="updateValue(item.id, $event.target)"
          (blur)="onInputBlur()"
          min="0"
          appPositiveNumber
        />
      </td>
    </tr>
  </tbody>
</table>
<app-error-message *ngIf="showError && formControl.touched" [validationErrors]="required ? { required: true } : null"></app-error-message>
